import React from 'react'
import PLANS from './plans.json'
import Modal from 'components/Modal'
import { Plans, Plan } from '../../components/Plan'
import './plans.css'
import Close from 'components/Close'
import { Query, Mutation } from 'react-apollo'
import {Elements} from 'react-stripe-elements';
import AddCard from 'components/AddCard'
import { SELECT_PLAN, ME } from 'operations/User'

export default class SelectPlan extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            plan: null,
            recurs: 'monthly'
        }

        this.handleClose = this.handleClose.bind(this)
        this.handleSelectPlan = this.handleSelectPlan.bind(this)
    }

    handleClose(e) {
        if (this.props.onClose) {
            this.props.onClose(e)
        }
    }

    handleSelectPlan(plan) {
        this.setState({
            plan
        })
    }
    
    render() {

        return (
            <Modal>
                <Close onClick={ this.handleClose } />

                <Query query={ ME }>
                    {({ loading, error, data }) => {
                        if (loading) return 'Loading...';
                        if (error) return `Error: ${error}`
                        
                        return (

                            <Mutation mutation={ SELECT_PLAN } refetchQueries={[{query: ME}]}>
                                {(selectPlan) => (
                                    // If no plan is select, have user select plan
                                    this.state.plan === null ? (
                                        <React.Fragment>
                                            <h1 className='selectPlan__heading'>Service that scales with you</h1>
                                            
                                            <div className='interval__container'>
                                                <button className={ this.state.recurs === 'monthly' ? 'active' : '' } onClick={() => { this.setState({ recurs: 'monthly' }) }}>Monthly</button>
                                                <button className={ this.state.recurs === 'annually' ? 'active' : '' } onClick={() => { this.setState({ recurs: 'annually' }) }}>
                                                    Annually
                                                    <div className='annual__discount'>Save 20%</div>
                                                </button>
                                                
                                            </div>
                                            
                                            <Plans>

                                                {
                                                    PLANS.map(({ title, subTitle, price, priceYearly, features }, i) => (
                                                        <Plan
                                                            title={ title }
                                                            subTitle={ subTitle }
                                                            price={ price }
                                                            priceYearly={ priceYearly }
                                                            features={features}
                                                            recurs={ this.state.recurs }
                                                            key={i}
                                                            onSelect={ (id) => {
                                                                if (data.me.account && data.me.account.stripeCustomerId && data.me.account.paymentSources) {
                                                                    selectPlan({
                                                                        variables: {
                                                                            data: {
                                                                                plan: PLANS[id].title,
                                                                                frequency: this.state.recurs
                                                                            }
                                                                        }
                                                                    })
                                                                    .then(({data}) => {
                                                                        if (data.selectPlan === 'SUCCESS') {
                                                                            this.handleClose()
                                                                        }
                                                                    })
                                                                    .catch(err => {
                                                                        console.log(err)
                                                                    })
                                                                }

                                                                else {
                                                                    this.setState({
                                                                        plan: id
                                                                    })
                                                                }
                                                            }}
                                                            id={i}
                                                        />
                                                    ))
                                                }
                                            </Plans>
                                        </React.Fragment>
                                    ) : (
                                        // If a plan has been selected
                                        <div className='modal__form'>
                                            <Elements>
                                                <AddCard onClose={ this.handleClose } plan={ PLANS[this.state.plan] }/>
                                            </Elements>
                                        </div>
                                    )

                                )}
                            </Mutation>
                        )
                    }}
                </Query>
            
            </Modal>
        )

    }
}


// WEBPACK FOOTER //
// ./src/components/SelectPlan/index.js